<template>
  <v-text-field :readonly="readonly" v-model="value" :label="prop.text" :clearable="!readonly" :color="prop.color"
    :name="prop.text" :error-messages="error" :mask="prop.mask" :id="prop.value" required>
  </v-text-field>
</template>

<style scoped>

</style>

<script>
  import TextInput from "./textInput.ts";
  export default TextInput;
</script>